import { RootState } from '../../types';

export const all = (state: RootState) => state.user.balance;
export const currencySymbol = (state: RootState) => all(state).main.symbol;
export const mainUpdatedAt = (state: RootState) => all(state).main.updatedAt;
export const balanceValue = (state: RootState) => +all(state).main.balance;
export const bonusBalance = (state: RootState) => all(state).bonus.balance;
